import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "@/data/content";

const LegalLayout = ({ title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 h-20 lg:h-24 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="C2 Advertising" className="h-12 lg:h-14 w-auto" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-magenta transition-colors"
          >
            <ArrowLeft size={16} />
            Înapoi la pagina principală
          </Link>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
          Document legal
        </div>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-3 text-sm text-slate-500">
            Ultima actualizare: {lastUpdated}
          </p>
        )}

        <div className="mt-10 prose-c2 space-y-6 text-slate-700 leading-relaxed">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-magenta transition-colors"
          >
            <ArrowLeft size={16} />
            Înapoi la pagina principală
          </Link>
        </div>
      </article>
    </div>
  );
};

export default LegalLayout;
